import { useEffect } from 'react';

import { SNOWPLOW_TRIGGER } from 'Utilities/analytics';
import { getNavigationTypeContext } from 'Utilities/analytics/snowplowNavigationContext';

import {
  OptimizelyScript,
  useBroadcast,
  useCognito,
  useCookieCheck,
  useGA,
  useOptimizely,
  useSignInConsent,
  useSnowplow,
  useStatSig,
  useUTM,
} from './initHooks';

const initHooks = [
  useBroadcast,
  useCookieCheck,
  useGA,
  useOptimizely,
  useSignInConsent,
  useSnowplow,
  useUTM,
  useCognito,
  useStatSig,
  // Needs to be the last hook. Only the document load carries the navigation type; route-change
  // page views (MetaTitle) are in-app navigations.
  () => useEffect(() => {
    SNOWPLOW_TRIGGER('trackPageView', { context: getNavigationTypeContext() });
  }, []),
]
  .map((hook) => () => {
    hook();
    return null;
  })
  .map((Hook, index) => (
    <Hook key={index} />
  ));

export const Init = () => (
  <>
    {initHooks}
    <OptimizelyScript />
  </>
);
